import AudioManager from "../Shared/AudioManager";
import UIManager from "../Shared/UIManager";
import {Global} from "../Shared/Global";
import Utils from "../Shared/Utils";
import NetworkLogic from "../Shared/NetworkLogic";
import Constant from "../Shared/Constant";
import SDKManager from "../Shared/SDKManager";
import Player from "../Models/Player";
const i18n = require('LanguageData');

const {ccclass, property} = cc._decorator;

@ccclass
export default class LoginCurrencyChoose extends cc.Component {
    @property(cc.Node)
    currencyToggleItem: cc.Node = null;
    @property(cc.Node)
    currencyToggleContent:cc.Node = null;
    @property(cc.Node)
    nodeTips:cc.Node = null;
    @property(cc.Node)
    currencyTips:cc.Node = null;
    @property(cc.Label)
    currencyLabel:cc.Label = null;
    @property(cc.Node)
    nodeCurrencyScroll : cc.Node = null;

    currencyLanguageDto = null;
    data = null;

    start () {

    }

    updateUI(data,currencyLanguageDto){
        this.data = data;
        this.createCurrencyList(currencyLanguageDto);
    }


    createCurrencyList(currencyList){
        for (let i = 0;i < currencyList.length;i++){
            let item = cc.instantiate(this.currencyToggleItem);
            item.parent = this.currencyToggleContent;
            item.getChildByName("lbBack").getComponent(cc.Label).string = currencyList[i].currencyName ;
            item.getComponent(cc.Button).clickEvents[0].customEventData = currencyList[i];
            item.active = true;
        }
    }


    onBtnChooseCurrency(){
        AudioManager.playSound("button")
        this.nodeCurrencyScroll.active = !this.nodeCurrencyScroll.active;
    }

    onBtnCurrencySelected(event,param){
        AudioManager.playSound("button")
        this.currencyTips.active = false;
        this.currencyLanguageDto = param;
        this.currencyLabel.string = param.currencyName;
        this.nodeCurrencyScroll.active = false;

    }

    onBtnTips(){
        AudioManager.playSound("button")
        this.nodeTips.active = true;
    }

    onBtnOk() {
        AudioManager.playSound("button");

        cc.log("====设备号：", Utils.getDeviceId());

        let data = {
            "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",
            "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",
            "domainId": Global.installParms.length === 2 ? Global.installParms[0] : "",
            "parentAgentCode": Global.installParms.length === 2 ? Global.installParms[1]['code'] : "",
            "currencyType" : this.currencyLanguageDto.currencyType
        }
        UIManager.showLoadingUI()
        NetworkLogic.visitorUserRegistered(data, function (rec) {
            UIManager.hideLoadingUI()
            cc.log("===注册成功", rec);
            if (Constant.InstallSDK === 0) {
                SDKManager.reportRegister()
            }else if (Constant.InstallSDK === 1) {
                SDKManager.shareInstallReportRegister()
            }
            //cc.director.emit(Global.UserEvent.AfterLogin);//登录之后
            Player.setPy("token", rec.token)
            UIManager.showVistorLoginTips()

        }.bind(this), function () {
            UIManager.hideLoadingUI()
            cc.log("===loginVisitorRegistered失败原因呢");//肯能是账号重复之类对
        }.bind(this));
        this.node.destroy();

    }

    onTipsOk(){
        this.nodeTips.active = false;
    }

}
